export default __webpack_public_path__ + "static/media/42k.d07910da.md";